import React, { Component } from 'react';

export interface TabSection {
  key: string;
  header: string;
  active: boolean;
  body: React.ReactNode;
  hideTabHeader?: boolean;
  onclick: (e?: React.MouseEvent<HTMLDivElement>) => void;
}

export interface TabsProps {
  sections: TabSection[];
}

export default class Tabs extends Component<TabsProps> {
  getHeaderClass = () => {
    const hideHeader = this.props.sections.filter((section) => section.hideTabHeader);
    return hideHeader.length > 0 ? 'tabs__header--slideup' : '';
  };

  render() {
    return (
      <div className='tabs'>
        <div className={`tabs__header ${this.getHeaderClass()}`}>
          <div className='tabs__header--wrap'>
            {this.props.sections.map((section) => (
              <div
                className={`tabs__header__nav ${section.active ? 'active' : ''}`}
                key={section.key}
                onClick={section.onclick}
              >
                {section.header}
              </div>
            ))}
            <span className='tabs__header--borderline'></span>
          </div>
        </div>
        <div className='tabs__body'>
          {this.props.sections
            .filter((section) => section.active)
            .map((section) => (
              <div key={section.key} className={`tabs__body__section active`}>
                {section.body}
              </div>
            ))}
        </div>
      </div>
    );
  }
}
